import { AfterViewInit, Component, ElementRef, Injector, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

// Rxjs
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

//Services
import { WebcomponentsService } from '@core/service/webcomponents.service';

// Shared
import { ONBOARDING_CARD_ENUMERATION } from '../shared';

const REDIRECT_TO_HOME_CONSTANT = '/home';
const REDIRECT_TO_CARD_ERROR_CONSTANT = '/card-error';
@Component({
  selector: 'app-card-terms-and-conditions',
  templateUrl: './card-terms-and-conditions.component.html',
})
export class CardTermsAndConditionsComponent implements AfterViewInit, OnDestroy {
  @ViewChild('onboardingViews', { static: false }) public onboardingViews: ElementRef;

  private readonly webComponentService: WebcomponentsService;
  private readonly router: Router;
  private readonly unSubscribe$: Subject<void>;

  constructor(private readonly injector: Injector) {
    this.webComponentService = this.injector.get(WebcomponentsService);
    this.router = this.injector.get(Router);
    this.unSubscribe$ = new Subject<void>();
  }

  public ngAfterViewInit(): void {
    this.renderOnboardingViews();
  }

  public ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  private renderOnboardingViews(): void {
    const creditList = this.onboardingViews.nativeElement;
    this.webComponentService.isLoaded$.pipe(takeUntil(this.unSubscribe$)).subscribe({
      next: (loaded) => {
        if (loaded) {
          creditList.ngElementStrategy?.componentRef?.instance?.build(
            ONBOARDING_CARD_ENUMERATION.CARD_TERMS_AND_CONDITIONS
          );
        }
      },
    });
  }

  public continueAction(): void {
    this.router.navigate([REDIRECT_TO_HOME_CONSTANT]);
  }

  public errorAction(): void {
    this.router.navigate([REDIRECT_TO_CARD_ERROR_CONSTANT]);
  }
}
